export default {
  ctrl: {
    save: "Spremi",
    cancel: "Otkaži",
    search: "Traži",
    size: "Veličina",
    file: "Datoteka",
    timestamp: "Vrijeme",
    name: "Ime",
    user: "Korisnik",
    close: "Zatvori",
    confirm: "Potvrdi",
    error: "Došlo je do greške!",
    errorCode: "Kod pogreške",
    remove: "Ukloni",
    selectCompetition: "Odaberite natjecanje",
    status: "Status",
    add: "Dodaj",
    language: "Jezik",
  },
  lang: {
    'sl-SI': "Slovenski",
    'en-US': "Engleski",
    'hr-HR': "Hrvatski"
  },
  langNative: {
    'sl-SI': "Slovensko",
    'en-US': "English" ,
    'hr-HR': "Hrvatski"
  },
  forms: {
    required: "Obvezno polje",
    invalidemail: "Nevažeća e-pošta"
  },
  login: {
    title: "Prijava",
    incorrect: "Adresa Vaše e-pošte ili lozinke je pogrešna",
    confirmationError: "Došlo je do pogreške prilikom potvrde adrese Vaše e-pošte.",
    confirmed: "Adresa e-pošte je potvrđena. Sada se možete prijaviti",
    forgotPassword: "Zaboravio sam lozinku"
  },
  registration: {
    title: "Registracija",
    required: "Obavezno polje",
    invalidEmail: "Nevažeća e-pošta",
    passwordMismatch: "Lozinke se ne podudaraju",
    passwordLength: "Lozinka mora imati najmanje 6 znakova",
    passwordNumerical: "Lozinka mora sadržavati najmanje jednu znamenku",
    registrationSuccessful: "Registracija je bila uspješna. Provjerite pristiglu poštu za poruku o potvrdi.",
    error: "Došlo je do pogreške u Vašoj registraciji."
  },
  "password-reset": {
    title: "Ponovno postavite lozinku",
    reset: "Ponovno postavi",
    message: "Veza za ponovno postavljanje lozinke poslana je na adresu"
  },
  "new-password": {
    title: "Izmjena lozinke",
    changeError: "Došlo je do pogreške prilikom ponovnog postavljanja lozinke.",
    changed: "Lozinka je uspješno promijenjena. Sada se možete prijaviti.",
    change: "Izmijeni lozinku"
  },
  dashboard: {
    title: "Upravljačka ploča"
  },
  competitors: {
    title: "Natjecatelji",
    firstName: "Ime",
    lastName: "Prezime",
    department: "Vatrogasna postrojba",
    gender: "Spol"
  },
  applications: {
    title: "Prijave",
    profileNotFilled: "Morate popuniti sva polja u profilu"
  },
  application: {
    competition: "Natjecanje",
    title: "Naziv ekipe",
    type: "Vrsta prijave",
    category: "Kategorija",
    unassigned: "Nedodijeljena",
    individual: "Pojedinac",
    tandem: "Tandem",
    relay: "Ekipa",
    code: "Kod",
    email: "E-pošta",
    remarks: "Napomene",
    payment: "Plaćanje",
    invoiceForDepartment: "Račun na društvo",
    invoiceAddress: "Adresa za račun",
    taxNumber: "Porezni br.",
    amount: "Iznos",
    reference: "Poziv",
    confirmations: "Potvrde",
    events: "Događaji",
    competitors: "Natjecatelji",
    confirmPayment: "Potvrdi plaćanje",
    confirmPaymentText: " Želite li potvrditi plaćanje?",
    new: "Nova prijava",
    summary: "Sažetak",
    price: "Cijena",
    cantAddCompetitor: "Ovog natjecatelja nema u sustavu odnosno još nema ispunjen profil",  
    noCycle: "Prijave za odabrano natjecanje trenutno su zatvorene.",
    submitTerms: "Slanjem ovog obrasca suglasni ste da organizator može objaviti i obraditi Vaše osobne podatke u svrhu natjecanja, u skladu sa zakonom. Podaci se čuvaju kod organizatora natjecanja.",
    failed: "Došlo je do pogreške prilikom dodavanja prijave.",
    duplicateError: "Prijava s tim natjecateljima već postoji.",
    incomplete: "Morate ispuniti sva obavezna polja."
  },
  payment: {
    receiver: "Primatelj",
    address: "Adresa",
    bank: "Banka",
    subject: "Svrha plaćanja",
    instructions: "Za potvrdu Vaše prijave, morate podmiriti kotizaciju. Podaci o plaćanju nalaze se ispod. Nakon plaćanja, putem donjeg obrasca, pošaljite nam potvrdu o plaćanju. Kotizaciju ne vraćamo, osim u slučaju više sile. Ako na dan natjecanja ne priložite odgovarajuće dokumente (osobni dokument i izvadak iz Vulkana) i time dokažete da ispunjavate uvjete za natjecanje, te Vam stoga natjecanje ne bude dozvoljeno, nećemo Vam vratiti kotizaciju.",
    uploadConfirmation: "Učitaj potvrdu",
    uploadError: "Došlo je do pogreške prilikom učitavanja potvrde",
  },
  competitor: {
    name: "Naziv",
    department: "Vatrogasna postrojba",
    shirtSize: "Veličina majice",
    shirt: "Majica",
    participation: "Sudjelovanje",
    checkedIn: "Check-in",
    email: "E-pošta",
    dateOfBirth: "Datum rođenja",
    address: "Adresa",
    country: "Država",
    telephone: "Telefon",
    bestTime: "Najbolje vrijeme",
    applications: "Prijave"
  },
  profile: {
    title: "Profil",
    firstname: "Ime",
    lastname: "Prezime",
    email: "E-pošta",
    dateofbirth: "Datum rođenja",
    gender: "Spol",
    address: "Adresa",
    telephone: "Telefonski broj",
    password: "Lozinka",
    repeatpassword: "Ponovite lozinku",
    male: "Muški",
    female: "Ženski",
    search: "Za dodavanje natjecatelja, unesite adresu e-pošte",
    saved: "Podaci o profilu spremljeni"
  },
  events: {
    ParticipationConfirmed: "Sudjelovanje potvrđeno",
    ApplicationFiled: "Prijava poslana",
    PaymentUploaded: "Plaćanje učitano",
    PaymentConfirmed: "Plaćanje potvrđeno"
  },
  server: {
    title: "Poslužitelj",
    requests: "Zahtjevi",
    logs: "Napomene"
  },
  races: {
    title: "Utrke"
  }
}
